<template>
  <div v-if="isLoading" class="loading-overlay-inside">
    <v-progress-circular
        :size="70"
        :width="7"
        color="primary"
        indeterminate
    ></v-progress-circular>
  </div>
  <div v-else>
    <div class="d-flex justify-content-center">
      <b-table
          class="table table-bordered w-75"
          hover
          responsive
          :fields="fields"
          :items="listTermsAndConditions"
          show-empty
      >
        <template #empty>
          <h1 class="text-center m-5">ไม่มีข้อมูลที่แสดง</h1>
        </template>
        <template #cell(action)="data">
          <div class="d-flex justify-content-evenly">
            <router-link
                :to="{
                name: 'DetailTermsAndConditions',
                query: { id: data.item.id },
              }"
                class="btn btn-outline-primary"
            >Edit
            </router-link
            >
          </div>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import TermsAndConditionsService from "services/api/termsAndConditions.service";

export default {
  data() {
    return {
      isLoading: false,
      listTermsAndConditions: [],
      fields: [
        {
          key: "friendlyName",
          label: "Type",
          thClass: "text-start",
          tdClass: "text-start",
          thStyle: {width: "80%"},
        },
        {
          key: "action",
          label: "Action",
          thStyle: {width: "20%"},
        },
      ],
      isSubmit: false,
    };
  },
  async mounted() {
    this.isLoading = true;
    await this.getTermsAndConditionsList();
  },
  methods: {
    async getTermsAndConditionsList() {
      await TermsAndConditionsService.getListTermsAndConditions()
          .then((res) => {
            const data = res.data;
            this.listTermsAndConditions = data.termsAndConditions.map((l) => {
              return {
                ...l
              };
            });
            this.isLoading = false;
          })
          .catch((err) => {
            console.log("Error: ", err);
            this.isLoading = false;
          });
    },
  },
};
</script>

<style scoped>
.loading-overlay-inside {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

</style>
